/*
*  Reason if no microchip is provided.
* @param {string} mc
* @param {string} mcWhyNot
* @param {function} setMcWhyNot
* @param {function} setMc
* @param {function} updateValue
* @param {object} row
* @param {boolean} hideMicrochipNumber
* @returns {JSX.Element}
 */
import {TextField} from "@mui/material";
import * as React from "react";

export default function RedeemVoucherWhyNotComponent({mc, hideMicrochipNumber, mcWhyNot, setMcWhyNot, updateValue, row, setRow}) {

    if (mc !== '') return null;
    if (hideMicrochipNumber === false) return null;
    return (
        <TextField
            hidden={!hideMicrochipNumber}
            error={(((mc === '' || mc.length !== 15) && mcWhyNot === ''))}
            sx={{width: 'calc(100%)'}}
            label="Reason if no microchip is provided."
            multiline
            maxRows={8}
            value={mcWhyNot}
            onChange={(e) => setMcWhyNot(e.target.value)}
            onBlur={
                (e) => {
                    updateValue(e.target.value, 'microchip_reason_why_not');
                    setRow({...row, microchip_reason_why_not: e.target.value})
                }
            }
        />
    )
}
